// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"slider_wrapper__QnBq4","title":"slider_title__KsxwG","grid":"slider_grid__te8mt"};